import React, { useState, useCallback } from 'react';
import Cropper from 'react-easy-crop';
import { Button, Slider,  Typography } from '@mui/material';
import { getCroppedImg } from './cropImage';
import moment from 'moment';
import axios from '../../axios';
import Switch from "react-switch"


const ImageCropper = ({ imageSrc, onCropComplete, onClose }) => {
  const [tokent, settokent] = useState(
    'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ',
  );
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  const [Active1, setActive1] = useState(false)

  const onCropChange = crop => {
    setCrop(crop);
  };

  const onZoomChange = zoom => {
    setZoom(zoom);
  };

  const onCropCompleteHandler = useCallback(
    (croppedArea, croppedAreaPixels) => {
      setCroppedAreaPixels(croppedAreaPixels);
    },
    [],
  );

  const onSave = async () => {
    try {
      const croppedImageFile = await getCroppedImg(imageSrc, croppedAreaPixels);
      console.log('croppedImageFile', croppedImageFile);
      InsertAdsBanner(croppedImageFile)

      
     
    } catch (e) {
      console.error(e);
    }
  };

  const InsertAdsBanner = async (croppedImageFile) => {
    // if (croppedImageBlob) {
      const formdata = new FormData();
      formdata.append("Ads_Image", croppedImageFile);
      formdata.append("Company_Id", sessionStorage.getItem("Companyid"));
      formdata.append("Branch_Id", sessionStorage.getItem("Branch_Log"));
      formdata.append("Created_By", 1);
      formdata.append("Created_On", moment(new Date()).format("YYYY-MM-DD"));
      formdata.append("Modify_By", 0);
      formdata.append("Modify_On", moment(new Date()).format("YYYY-MM-DD"));
      formdata.append("OpType", "New");
      formdata.append("Active", Active1?'Y':'N');

      const LRDocument = await axios.instance
        .post(`/InsertAdsBanner`, formdata, {
          headers: {
            Authorization: tokent,
            "Content-Type": "multipart/form-data",
          },
        })
        .then(async res => {
          onCropComplete(true,croppedImageFile);
        });
  
  }

  // const getalldata = async () => {
  //   await axios.instance
  //     .get(
  //       `GetAllAdsBanner/${sessionStorage.getItem(
  //         'Companyid',
  //       )}/${sessionStorage.getItem('Branch_Log')}`,
  //       {
  //         headers: {
  //           Authorization: tokent,
  //           'Content-Type': 'multipart/form-data',
  //         },
  //       },
  //     )

  //     .then(res => {
  //       settabledata(res.data, 'tabledata');
  //       console.log(res.data);
  //     });
  // };


  return (
    <div>
      <Cropper
        image={imageSrc}
        crop={crop}
        zoom={zoom}
        aspect={728 / 80}
        onCropChange={onCropChange}
        onZoomChange={onZoomChange}
        onCropComplete={onCropCompleteHandler}
      />
      <div>
        {/* <Typography>Zoom</Typography>
        <Slider
          value={zoom}
          min={1}
          max={3}
          step={0.1}
          onChange={(e, zoom) => onZoomChange(zoom)}
        /> */}
      </div>
      <Button variant="contained" color="primary"  style={{marginRight:'10px'}} onClick={onSave}>
        Save
      </Button>
      <Button variant="contained" color="secondary" onClick={onClose}>
        Cancel
      </Button>      
    </div>
  );
};

export default ImageCropper;
